export default theme => ({
    card: {
        display: 'flex',
        boxShadow: 'none',
    },
    content: {
        flex: '1 0 auto',
    },
    paperStyle: {
        width: '430px',
        height: '500px',
        display: 'inline-block',
        margin: 20,
        marginTop: '13vh'
    },
    buttonStyle: {
        width: '123px',
        height: '36px',
        marginTop: 42,
        fontSize: '13px',
        color: '#FFF',
        background: '#002053',
        borderRadius: '3px',
        textTransform: 'capitalize',
        boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.25)',
        '&:hover': {
            backgroundColor: '#002053',
        },
    },
    textField: {
        width: 350
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    headerStyle: {
        position: 'relative',
        width: '100%',
        height: '60px',
        background: '#FFFFFF',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
        borderRadius: '10px',
    },
    headerTitleStyle: {
        flexDirection: 'column',
        margin: '2%',
        fontSize: '24px',
        fontFamily: 'Roboto'
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    errorPaperStyle: {
        display: 'inline-block',
        width: '75%',
        background: '#F2F2F2',
        fontSize: '13px',
        border: '2px solid #FA1414',
        boxSizing: 'border-box',
        boxShadow: '0px 15px 10px rgba(0, 0, 0, 0.25)',
        borderRadius: '10px',
        marginBottom: 10
    },
    linkButton: {
        width: '99px',
        padding: 'inherit',
        height: '15px',
        fontStyle: 'normal',
        fontWeight: 'normal',
        lineHeight: 'normal',
        fontSize: '13px',
        textDecoration: 'none',
        color: '#000000',
        margin: 10,
        textTransform: 'capitalize'
    },
    textFieldInput: {
        padding: 'inherit',
    },
    label: {
        fontStyle: 'normal',
        fontWeight: 'normal',
        lineHeight: 'normal',
        fontSize: '12px',
        whiteSpace: 'nowrap',
        textAlign: 'center',
        color: 'rgba(0, 0, 0, 0.5)'
    },
    buttonLabel: {
        fontStyle: 'normal',
        fontWeight: 'normal',
        lineHeight: 'normal',
        fontSize: '14px',
        textAlign: 'center',
        color: '#FFFFFF',
        borderRadius: '3px',
    },
    '@media print': {
        printable: {
          display: 'block'
        },
        nonPrintable: {
          display: 'none'
        }
    }
});


// WEBPACK FOOTER //
// ./src/components/Styles/style.js